import { useQueryClient } from '@tanstack/react-query';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { MessageThread } from '@/features/Messages/MessageThread';
import { useTrainerMessageThread, useSendTrainerMessage } from '@/lib/hooks/useTrainerMessages';
import { queryKeys } from '@/lib/queryKeys';

interface Props {
  batchId: string;
  open: boolean;
  onClose: () => void;
}

export function TrainerMessagesSheet({ batchId, open, onClose }: Props) {
  const qc = useQueryClient();
  const { data, isLoading } = useTrainerMessageThread(batchId, '', open);
  const send = useSendTrainerMessage([...queryKeys.trainerMessages.thread(batchId, '')]);

  const sendAndRefreshOverview = (body: string) => {
    send.mutate(
      { batch_id: batchId, body },
      {
        onSuccess: () => {
          qc.invalidateQueries({ queryKey: queryKeys.trainer.batchOverview(batchId) });
        },
      },
    );
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader><DialogTitle>Message org admin</DialogTitle></DialogHeader>
        <MessageThread
          messages={data?.messages ?? []}
          self={data?.self ?? ''}
          loading={isLoading}
          sending={send.isPending}
          emptyText="No messages from your org admin yet."
          onSend={sendAndRefreshOverview}
        />
      </DialogContent>
    </Dialog>
  );
}
